// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"82edea4b","264":"01625cc9","290":"ef28b177","358":"8daf16dc","420":"f565f521","571":"17b32d5f","672":"9949badd"}[chunkId] + ".chunk.js";
};